import { useState } from 'react';
import './react-phone-number-input.css';
import Iconify from 'src/components/Iconify';
import PhoneInput from 'react-phone-number-input';
import { Input } from 'src/@/components/ui/input';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Label } from 'src/@/components/ui/label';

export default function NovoChatForm({
    callbackAddContact,
    showSignupButton,
    loadingNovoContato
}) {
    const [contato, setContato] = useState({
        nome: '',
        whatsapp: ''
    });

    const handleCallbackAddContact = () => {
        let data = { contato };
        callbackAddContact(data);
        clearFields();
    };

    function clearFields() {
        setContato({
            nome: '',
            whatsapp: ''
        });
    }

    return (
        <div className="flex flex-col space-y-5">
            <div className="space-y-4">
                <div className="space-y-2">
                    <Label className="text-sm font-medium text-foreground">
                        Nome do contato <span className="text-red-500">*</span>
                    </Label>
                    <Input
                        placeholder="Ex: João da Silva"
                        onChange={e => setContato({ ...contato, nome: e.target.value })}
                        value={contato.nome}
                        className="h-10 bg-background"
                    />
                </div>
                
                <div className="space-y-2">
                    <Label className="text-sm font-medium text-foreground">
                        Telefone (WhatsApp) <span className="text-red-500">*</span>
                    </Label>
                    <PhoneInput
                        international
                        defaultCountry='BR'
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring"
                        placeholder="Insira o número"
                        value={contato.whatsapp}
                        onChange={value => setContato({ ...contato, whatsapp: value })}
                    />
                </div>
            </div>

            {showSignupButton && (
                <div className="pt-2">
                    <ButtonLoading
                        loading={loadingNovoContato}
                        onClick={handleCallbackAddContact}
                        className="w-full h-10 bg-violet-600 hover:bg-violet-700 text-white rounded-md flex items-center justify-center gap-2 transition-colors font-medium shadow-sm transition-all shadow-violet-500/20 hover:shadow-violet-500/40"
                    >
                        <Iconify icon="mdi:chat-plus-outline" className="w-[18px] h-[18px]" /> 
                        Iniciar Conversa
                    </ButtonLoading>
                </div>
            )}
        </div>
    );
}